module.exports = __webpack_public_path__ + "img/图标5.8c077797.png";